import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  params: any;
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  params: {}
};

export const conversationReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_CONVERSATION_CREATE_REQUEST:
    case Constants.GLOBAL_CONVERSATION_UPDATE_REQUEST:
    case Constants.GLOBAL_CONVERSATION_STATUS_UPDATE_REQUEST:
    case Constants.GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_REQUEST:
    case Constants.GLOBAL_CONVERSATION_READ_UPDATE_REQUEST:
    case Constants.GLOBAL_MESSAGE_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_CONVERSATION_CREATE_SUCCESS:
    case Constants.GLOBAL_CONVERSATION_UPDATE_SUCCESS:
    case Constants.GLOBAL_CONVERSATION_STATUS_UPDATE_SUCCESS:
    case Constants.GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_SUCCESS:
    case Constants.GLOBAL_CONVERSATION_READ_UPDATE_SUCCESS:
    case Constants.GLOBAL_MESSAGE_CREATE_SUCCESS:
    return {
      ...state,
      isFetching: false
    };

    case Constants.GLOBAL_CONVERSATION_CREATE_FAILURE:
    case Constants.GLOBAL_CONVERSATION_UPDATE_FAILURE:
    case Constants.GLOBAL_CONVERSATION_STATUS_UPDATE_FAILURE:
    case Constants.GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_FAILURE:
    case Constants.GLOBAL_CONVERSATION_READ_UPDATE_FAILURE:
    case Constants.GLOBAL_MESSAGE_CREATE_FAILURE:
    case Constants.PAGE_CONTACT_PERSON_UPDATE_FAILURE:
    case Constants.CHECK_PHONE_NUMBER_FAILURE:
      const errorFields = action.payload?.err.fields || [];

      if (action.payload?.err?.errorId?.toLowerCase() === "email_address_required") {
        errorFields.push("email");
      }

      if (action.payload?.err?.errorId?.toLowerCase() === "mobile_phone_required") {
        errorFields.push("mobilePhone");
      }

      return {
        ...state,
        isFetching: false,
        fields: errorFields,
        translatedMessage: action.payload?.err.translatedMessage
      };
      
    case Constants.GLOBAL_CONVERSATION_CREATE_CLEAR:
    case Constants.GLOBAL_CONVERSATION_UPDATE_CLEAR:
    case Constants.GLOBAL_CONVERSATION_STATUS_UPDATE_CLEAR:
    case Constants.GLOBAL_CONVERSATION_NOTIFICATION_CHANNELS_UPDATE_CLEAR:
    case Constants.GLOBAL_CONVERSATION_READ_UPDATE_CLEAR:
    case Constants.GLOBAL_MESSAGE_CREATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
